import React from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';
import { fitImage, noteHeight, noteWidth } from '../util/notes.mjs';
import useNoteGesture from '../hooks/useNoteGesture.js';

const BoardImage = function({note, layer, selected, onSelect, onChange, onDelete}) {
  const {isDragging, getHandleProps} = useNoteGesture(note, onChange);

  return <article
    className={`note boardImage ${note.minimized ? 'isMinimized' : ''} ${selected ? 'isSelected' : ''} ${isDragging ? 'isDragging' : ''}`}
    data-note-id={note.id}
    aria-label={note.images[0]?.name || 'board image'}
    onPointerDownCapture={() => onSelect(note.id)}
    onFocusCapture={() => onSelect(note.id)}
    style={{
      translate: `${note.x}px ${note.y}px`,
      width: noteWidth(note),
      height: noteHeight(note),
      zIndex: layer
    }}
  >
      <button
        className='boardImageDrag'
        aria-label='move image; use arrow keys when focused'
        {...getHandleProps('move')}
      >
        {note.images.map(image => <img
          key={image.id}
          src={image.src}
          alt={image.name}
          draggable={false}
          onLoad={event => {
            if (note.aspectRatio) return;

            const image = event.currentTarget;
            const board = image.closest('.board');

            if (!image.naturalWidth || !image.naturalHeight) return;

            onChange(note.id, fitImage(image.naturalWidth, image.naturalHeight, board.clientWidth, board.clientHeight, Number(board.dataset.zoom) || 1));
          }}
        />)}
      </button>
      {selected && <button
        className='deleteNoteButton boardImageDelete'
        aria-label='delete image'
        title='delete image'
        onClick={() => onDelete(note.id)}
      ><span aria-hidden='true' /></button>}
      {selected && <button
        className='minimizeNoteButton boardImageMinimize'
        aria-label={note.minimized ? 'expand image' : 'minimize image'}
        aria-expanded={!note.minimized}
        title={note.minimized ? 'expand image' : 'minimize image'}
        onClick={() => onChange(note.id, {minimized: !note.minimized})}
      >
        {note.minimized ? <FiPlus size={12} aria-hidden='true' /> : <FiMinus size={12} aria-hidden='true' />}
      </button>}
      {!note.minimized && <button
        className='resizeHandle'
        aria-label='resize image; use arrow keys when focused'
        title='drag to resize · arrow keys to adjust'
        {...getHandleProps('resize')}
      />}
    </article>;
};

export default BoardImage;
